import { Component, DestroyRef, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { CommonModule } from '@angular/common';
import { Router, NavigationEnd, RouterLink, RouterLinkActive } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { filter } from 'rxjs';
import { SpacesService } from '../../../services/spaces.service';
import { Space } from '../../../models/space.model';

interface NavItem {
  labelKey: string;
  route: string;
}

@Component({
    selector: 'app-spaces-sidebar',
    imports: [CommonModule, TranslateModule, RouterLink, RouterLinkActive],
    templateUrl: './spaces-sidebar.component.html',
    styleUrl: './spaces-sidebar.component.scss'
})
export class SpacesSidebarComponent implements OnInit {
  spaces$ = this.spacesService.spaces$;
  currentRoute = '';
  private readonly destroyRef = inject(DestroyRef);

  constructor(
    private readonly router: Router,
    private readonly spacesService: SpacesService,
  ) {}

  ngOnInit(): void {
    this.currentRoute = this.router.url;
    this.router.events
      .pipe(
        filter((e): e is NavigationEnd => e instanceof NavigationEnd),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe(e => {
        this.currentRoute = e.urlAfterRedirects;
      });
  }

  get isOverviewActive(): boolean {
    return this.currentRoute === '/spaces';
  }

  get isInSpaceDetail(): boolean {
    return this.currentRoute.startsWith('/spaces/') && this.currentRoute !== '/spaces';
  }

  get currentSpaceId(): string {
    const segments = this.currentRoute.split('/');
    // /spaces/:spaceId/... → index 2
    return segments.length >= 3 ? segments[2] : '';
  }

  isSpaceExpanded(space: Space): boolean {
    return this.currentSpaceId === space.id;
  }

  getNavItems(space: Space): NavItem[] {
    return [
      { labelKey: 'SIDEBAR.COMPANY_FIT', route: `/spaces/${space.id}/company-fit` },
      { labelKey: 'SIDEBAR.VALUE_ANALYSIS', route: `/spaces/${space.id}/value-analysis` },
      //{ labelKey: 'SIDEBAR.DEMO_AND_PROOFS', route: `/spaces/${space.id}/demo-and-proofs` }
    ];
  }

  goToOverview(): void {
    this.router.navigate(['/spaces']);
  }

  openSpace(space: Space): void {
    this.router.navigate(['/spaces', space.id]);
  }
}

